import {
  GenericTag,
} from '../../types/components'

import * as yup from 'yup'

import {
  FormSchema,
} from '../../types/form'

import {
  IRecord_WithMaybeTags,
} from '@kaidam/fc-shared/src/types/utils'

import {
  IRecord_CRMContact_Core,
  IRecord_CRMContact_Update,
  IRecord_CRMContact_WithData,
} from '@kaidam/fc-shared/src/types/schema/crm'

export type FormType = IRecord_CRMContact_Core & IRecord_WithMaybeTags

export const formSchema: FormSchema = [{
  id: 'firstname',
  title: 'Firstname',
}, {
  id: 'surname',
  title: 'Surname',
}, {
  id: 'email',
  title: 'Email',
}, {
  id: 'phone_number',
  title: 'Phone Number',
}, {
  id: 'phone_number2',
  title: 'Secondary Phone Number',
}, {
  id: 'address1',
  title: 'Address 1',
}, {
  id: 'address2',
  title: 'Address 2',
}, {
  id: 'city',
  title: 'City',
}, {
  id: 'postcode',
  title: 'Postcode',
}, {
  id: 'country',
  title: 'Country',
}]

export const getCRMFormSchema = (tags: GenericTag[]): FormSchema => {
  const tagForm: FormSchema = [{
    id: 'tags',
    title: 'Tags',
    component: 'tags',
    meta: {
      tags,
    }
  }]

  const extraFields: FormSchema = [{
    id: 'magic_tags',
    title: 'Custom Fields',
    helperText: 'You can add whatever data you want to these rows, just click and type to add data',
    component: 'metadata',
  }, {
    id: 'unsubscribed',
    title: 'unsubscribed?',
    component: 'checkbox',
    meta: {
      notitle: true,
    },
  }, {
    id: 'bad_address',
    title: 'bad email address?',
    component: 'checkbox',
    meta: {
      notitle: true,
    },
  }]

  return tagForm.concat(formSchema).concat(extraFields)
}

export const validationSchema = yup.object().shape({
  firstname: yup.string().nullable(),
  surname: yup.string().nullable(),
  email: yup.string().email().required(),
  phone_number: yup.string().nullable(),
  phone_number2: yup.string().nullable(),
  address1: yup.string().nullable(),
  address2: yup.string().nullable(),
  city: yup.string().nullable(),
  postcode: yup.string().nullable(),
  country: yup.string().nullable(),
})

export const emptyValues: FormType = {
  firstname: '',
  surname: '',
  email: '',
  phone_number: '',
  phone_number2: '',
  address1: '',
  address2: '',
  city: '',
  postcode: '',
  country: '',
  tags: [],
}

export const dataToForm = (item: IRecord_CRMContact_WithData): FormType => ({
  firstname: item.firstname,
  surname: item.surname,
  email: item.email,
  phone_number: item.phone_number,
  phone_number2: item.phone_number2,
  address1: item.address1,
  address2: item.address2,
  city: item.city,
  postcode: item.postcode,
  country: item.country,
  tags: item.tags || [],
  magic_tags: item.magic_tags,
  unsubscribed: item.unsubscribed ? true : false,
  bad_address: item.bad_address ? true : false,
})

export const formToData = (form: FormType): IRecord_CRMContact_Update & IRecord_WithMaybeTags => form
